<template>
  <div style="background-color: #fff">
    <van-search
      v-if="ffid < 3"
      v-model="keyword"
      placeholder="请输入搜索关键词"
      @search="onSearch"
      @clear="cleacKeyword"
    >
      <template #left>
        <van-dropdown-menu class="search-type">
          <van-dropdown-item class="search-type-item" v-model="searchType" :options="searchTypeOption" />
        </van-dropdown-menu>
      </template>
    </van-search>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" >
      <van-list
        v-model="loading"
        :error.sync="empty"
        error-text="尚未报名"
        :finished="finished"
        :finished-text="`${ffid == 12 ? '' : '没有更多了'}`"
        @load="onLoad"
        :style="`min-height: ${ffid == 12 ? 55 : (ffid < 3 ? 80 : 60)}vh;`"
      >
        <div v-for="item in list" :key="item.id">
          <div class="space"></div>
          <van-cell-group  inset>
            <van-cell is-link title-class="name" :title="item.name" :value="item.created_at"  @click="showDetail(item.id)"/>
            <van-cell v-if="item.id_number" :value="`${item.id_number}  - -  ${item.telephone}`"/>
            <van-cell v-else-if="item.title" :value="`${item.title}  - -${item.telephone}`"/>
          </van-cell-group>
          <div class="space"></div>
        </div>
        
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import axios from 'axios'
import { util } from '../assets/common2.js'

export default {
  name: 'ListComponent',
  props: {
    active: String,
    refresh: Boolean,
    carModify: Boolean,
    ffid: String,
    status: Number
  },
  data () {
    return {
      list: [],
      empty: false,
      loading: false,
      finished: false,
      refreshing: false,
      keyword: '',
      searchType: 'name',
      searchTypeOption: [
        { text: '姓名', value: 'name' },
        { text: '身份证', value: 'id_number' },
        { text: '手机号', value: 'telephone' },
      ],
      filter: {}
    }
  },
  components: {

    // CommentComponent
  },
  computed: {
    start() {
      return this.list.length
    }
  },
  created: function () {
    this.filter.status = this.status
    // this.active = this.$store.state.prevActive
  },
  mounted: function () {
    
  },
  methods: {
    showDetail (form_id) {
      if (this.carModify) {
        this.$router.push('/car/form/'+form_id)
      } else if (this.ffid > 3 && this.ffid < 11) {
        this.$router.push(`/house/detail/${this.ffid}/${form_id}`)
      } else if (this.ffid == '3') {
        this.$router.push('/car/oldfornewdetail/'+form_id)
      } else if (this.ffid == '12') {
        this.$router.push('/runner/detail/'+form_id)
      } else if (this.ffid == '14') {
        this.$router.push('/ymwhxj/detail/'+form_id)
      } else {
        this.$router.push('/car/detail/'+form_id)
      }
    },
    onRefresh () {
      this.list = []
      this.finished = false;
      this.loading = true;
      this.onLoad();
    },
    onSearch (val) {
      this.filter[this.searchType] = val
      this.list = []
      this.finished = false;
      if (this.refreshing) {
        this.refreshing = false;
      }
    },
    cleacKeyword () {
      this.filter = {status:this.status}
      this.onRefresh()
    },
    onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
      }
      this.loadHandle({})
    },
    loadHandle() {
      util.Arequest((data) => {
        var formData = new FormData()
        formData.append('token',data.token)
        formData.append('userid',data.userid)
        for (const key in this.filter) {
          formData.append(key,this.filter[key])
        } 
        axios.post(`/encrypt3/form/get?fid=${this.$store.state.fid}&start=${this.start}&size=50`,formData).then(res => {
            if (res.data.msg == 'ok') {
              this.list = this.list.concat(res.data.forms)
              if (this.list.length == 0 && this.ffid == 12) {
                this.empty = true
              }
              this.loading = false;
              if (res.data.forms.length < 50) {
                this.finished = true
              }
            } else if (res.data.msg == 'not admin') {
              this.$toast('无权限')
              this.finished = true
            } else {
              this.$toast('网络繁忙\n请重试')
              this.finished = true
            } 
          }).catch(() => {
            this.$toast('活动火爆\n请重试')
            setTimeout(() => {
              this.finished = true
            },2000)
          })
      })
    }
  },
  watch: {
    refresh(n,o) {
      if (n == true && o == false && this.status == parseInt(this.active)) {
        this.onRefresh()
        this.$emit('refreshed')
      }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.list {
  width: 100%;
  min-height: 100vh;
}
.space {
  width: 100%;
  height: 0.5rem;
}
.name {
  text-align: left;
}
.search-type {
  width: 4rem;
  
}
</style>
<style>
.search-type .van-dropdown-menu__bar {
  height: 34px;
}
.search-type .van-dropdown-menu__title {
  font-size: 0.85rem !important;
}
</style>
